var _a;
/**
 * 统一注册移动端所有service
 */
import MegaTransport from './mega-transport';
class ServiceHost {
    constructor() {
        this.transport = new MegaTransport();
        this.services = new Map();
    }
    static get transport() {
        return this.instance.transport;
    }
    static register({ services, onRegisterError } = {}) {
        Object.entries(services !== null && services !== void 0 ? services : {}).forEach(([name, service]) => {
            try {
                ServiceHost.instance.registerService(name, service);
            }
            catch (err) {
                if (!onRegisterError) {
                    throw err;
                }
                else {
                    onRegisterError === null || onRegisterError === void 0 ? void 0 : onRegisterError(name, err);
                }
            }
        });
    }
    static getService(name) {
        const service = this.instance.services.get(name);
        if (!service) {
            throw new Error(`Service "${name}" not found`);
        }
        return service;
    }
    registerService(serviceName, service) {
        if (this.services.has(serviceName)) {
            throw new Error(`Service "${serviceName}" is already registered`);
        }
        if (!Number.isInteger(service.version) && service.version <= 0) {
            throw new Error(`Service ${serviceName}: version ${service.version} is not an integer greater than 0`);
        }
        this.services.set(serviceName, service);
    }
}
_a = ServiceHost;
ServiceHost.instance = new _a();
export default ServiceHost;
//# sourceMappingURL=service-host.js.map